import { PERMISSIONS } from "@/services/permission"

export default [
  {
    path: "/hourlywageinvoice",
    name: "HourlywageinvoiceWizard",
    component: () => import("@/views/hourlywageinvoice/HourlywageinvoiceWizard"),
    meta: {
      title: "nav.invoice",
      requiresAuth: true,
      requiresPermissions: [
        PERMISSIONS.VIEW_ASSIGNED_PROJECT_HOURLYWAGEINVOICE,
        PERMISSIONS.VIEW_FOREIGN_PROJECT_HOURLYWAGEINVOICE,
      ],
    },
  },
]
